import React from 'react';
import { Helmet } from 'react-helmet';

import { motion } from 'framer-motion';

import useRedirect from '../../hooks/useRedirect';
import Button from '../Button';
import FloatingButton from '../FloatingButton';
import Footer from '../Footer';
import Header from '../Header';
import SubHeader from '../Header/SubHeader';
import InstructionModal from '../InstructionModal';
import {
  Container,
  Wrapper,
  Main,
  TitleContent,
  TitlePage,
  ButtonContainer,
} from './styles';

interface LayoutProps {
  title?: string;
  hideBackbar?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  hideFloatingButton?: boolean;
  hideInstructionModal?: boolean;
  headerProtect?: boolean;
  buttonTitle?: string;
  buttonRedirect?: string;
  titlePage?: string;
}

const pageTransition = {
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: 15,
  },
};

export const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  hideBackbar = false,
  hideHeader = false,
  hideFooter = false,
  hideFloatingButton = false,
  hideInstructionModal = false,
  headerProtect = false,
  buttonTitle,
  buttonRedirect,
  titlePage,
  ...rest
}) => {
  const redirect = useRedirect();

  return (
    <>
      <Helmet
        title={
          titlePage
            ? titlePage + ' | Portal Homologação'
            : 'Unicred | Portal Homologação'
        }
      />
      {!hideFloatingButton && <FloatingButton />}
      {!hideInstructionModal && <InstructionModal />}
      {!hideHeader && <Header protect={headerProtect} />}
      {!hideBackbar && (
        <SubHeader title="Lista de Perfis">
          {buttonTitle && (
            <ButtonContainer>
              <Button
                variant="outline"
                color="#fff"
                onClick={() => {
                  redirect(`${buttonRedirect}`);
                }}
              >
                {buttonTitle}
              </Button>
            </ButtonContainer>
          )}
        </SubHeader>
      )}
      <Main>
        <motion.div
          initial={'out'}
          animate={'in'}
          exit={'out'}
          variants={pageTransition}
        >
          {title && (
            <TitleContent>
              <Container>
                <TitlePage>
                  <h1>{title}</h1>
                  <hr />
                </TitlePage>
              </Container>
            </TitleContent>
          )}
          <Wrapper>{children}</Wrapper>
        </motion.div>
      </Main>
      {!hideFooter && <Footer />}
    </>
  );
};
